import { MiddleMsResynchronisationRequestType } from "@/api/graphql/types/graphql";

export const DRAWER_WIDTH = "40%";
export const MAX_ROWS = 4;
export const MAX_ACCOUNTS_INPUT_LENGTH = 1000;

export const RESYNCHRONISATION_TYPES = (t: (query: string) => string) => [
  {
    label: t("migrationReport.drawer.sync.type.all"),
    value: MiddleMsResynchronisationRequestType.ResyncTypeAll,
  },
  {
    label: t("migrationReport.drawer.sync.type.contract"),
    value: MiddleMsResynchronisationRequestType.ResyncTypeContract,
  },
  {
    label: t("migrationReport.drawer.sync.type.driverCode"),
    value: MiddleMsResynchronisationRequestType.ResyncTypeDriverCode,
  },
  {
    label: t("migrationReport.drawer.sync.type.product"),
    value: MiddleMsResynchronisationRequestType.ResyncTypeProduct,
  },
  {
    label: t("migrationReport.drawer.sync.type.structure"),
    value: MiddleMsResynchronisationRequestType.ResyncTypeStructure,
  },
  {
    label: t("migrationReport.drawer.sync.type.unknown"),
    value: MiddleMsResynchronisationRequestType.ResyncTypeUnknown,
  },
];
